export default __webpack_public_path__ + "static/Tek_Foundation-21a933013fe1d65f5143aded3bed7353.png";